<template>
  <div class="container">
    <div class="mx-auto fixed-width-form">
      <legend>Печать отправки на день</legend>
      <form @submit.prevent="searchOrders" ref="searchOrders">
        <div class="form-group row">
          <div class="col-md-6">
            <label>Дата отправки</label>
            <date-picker class="w-100" v-model="dispatchDate" valueType="format"
                         format="DD-MM-YYYY"
                         :input-attr="{required: true}"
                         :first-day-of-week="1" lang="ru"></date-picker>
          </div>
          <div class="col-md-6">
            <label>Объезд</label>
            <v-select v-model="currentTour" label="Name"
                      :options="tours">
              <template #search="{attributes, events}">
                <input
                  class="vs__search"
                  :required="!currentTour"
                  v-bind="attributes"
                  v-on="events"
                />
              </template>
            </v-select>
          </div>
        </div>
        <div class="form-group row">
          <div class="col-md-12 text-right">
            <button @click.prevent="print" class="btn btn-warning ml-2">Печать</button>
            <button type="submit" class="btn btn-primary ml-2">Искать</button>
            <button type="button" class="btn btn-secondary ml-2" @click.prevent="resetForm">Очистить</button>
          </div>
        </div>
      </form>
    </div>
    <div class="mx-auto fixed-width-form" v-if="lastDispatches.length && !orders.length">
      <legend>Последние отправки</legend>
      <table class="table table-bordered table-sm text-center table-hover">
        <tbody>
        <tr v-for="dispatch in lastDispatches">
          <td>{{dispatch.Date}}</td>
          <td>{{dispatch.TourName}}</td>
          <td>{{dispatch.Count}}</td>
          <td><a href="#" @click.prevent="setFormData(dispatch)">Искать</a></td>
        </tr>
        </tbody>
      </table>
    </div>
    <div class="container" id="printMe">
      <div class="display-4 text-center" v-if="isLoading">Загрузка...</div>
      <div class="display-4 text-center" v-else-if="!receptions.length && isDirty">Нет заказов.</div>
      <div v-else-if="receptions.length" v-for="(reception, index) in receptions">
        <table class="table table-bordered table-sm text-center">
          <thead v-if="index === 0">
          <tr>
            <th>{{currentTour.Name}}</th>
            <th colspan="2" class="text-right">Итого по объезду</th>
            <th v-for="tourS in tourSummary">
              {{tourS.Summary}}
            </th>
            <th></th>
          </tr>
          </thead>
          <thead>
          <tr>
            <th style="width: 200px;">{{getHeadPartnerReception(reception.orders)}}</th>
            <th style="width: 1000px;">Артикул</th>
            <th style="width: 50px;">Кол-во</th>
            <th style="width: 50px;" v-for="paymentType in $root.paymentTypes">
              {{paymentType.Name}}
            </th>
            <th width="200">Код</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="order in reception.orders">
            <td>
              {{order.RecastNumber > 0 ? 'Переделка заказа ' : ''}} {{order.SferaNumber}} {{order.LocalNumber && ` / ${order.LocalNumber}`}}
            </td>
            <td>
              {{order.Name}}
            </td>
            <td>
              {{order.Amount}}
            </td>
            <td v-for="paymentType in $root.paymentTypes">
              {{order.PaymentTypeId === paymentType.Id ? order.Summary : null}}
            </td>
            <td>
              <vue-barcode :value="order.SferaNumber" width="2" height="20" :margin="0" display-value="false">
                Ошибка штрихкода
              </vue-barcode>
            </td>
          </tr>
          </tbody>
          <tfoot>
          <tr>
            <th colspan="3" class="text-right">Итого</th>
            <th v-for="paymentTypeSummary in reception.paymentTypes">{{paymentTypeSummary.Summary}}</th>
            <th></th>
          </tr>
          </tfoot>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import DatePicker from 'vue2-datepicker';
import _ from 'lodash';
import VueBarcode from 'vue-barcode';
import { get } from '@/admin/services/api/http-utils';
import OrderPrintBlankSmall from '@/admin/components/OrderPrintBlankSmall.vue';

const url = `${process.env.VUE_APP_API_HOST}admin/dispatch`;


export default {
  components: {
    DatePicker,
    OrderPrintBlankSmall,
    VueBarcode,
  },
  data() {
    return {
      tours: [],
      currentTour: null,
      dispatchDate: null,
      orders: [],
      isLoading: false,
      isDirty: false,
      lastDispatches: [],
    };
  },
  async mounted() {
    await this.fetchTours();
    await this.fetchLastDispatches();
  },
  computed: {
    receptions() {
      let receptions = _.groupBy(this.orders, 'CustomerId');
      receptions = _.map(receptions, (orders) => {
        function customizer(value, index, object, stack) {
          if (index === 'Summary') {
            object.Summary = 0;
          }
        }
        let receptionSummary = _.cloneDeepWith(this.$root.paymentTypes, customizer);
        receptionSummary = _.mapKeys(receptionSummary, item => item.Id);
        _.forEach(orders, (order) => {
          // if (!receptionSummary[order.PaymentTypeId].Summary) {
          //   receptionSummary[order.PaymentTypeId].Summary = 0;
          // }
          receptionSummary[order.PaymentTypeId].Summary = receptionSummary[order.PaymentTypeId].Summary || 0;
          receptionSummary[order.PaymentTypeId].Summary += order.Summary;
        });

        return {
          orders,
          paymentTypes: _.values(receptionSummary),
        };
      });
      console.log(_.values(receptions));
      return _.values(receptions);
    },
    tourSummary() {
      if (!this.orders) return false;
      function customizer(value, index, object, stack) {
        if (index === 'Summary') {
          object.Summary = 0;
        }
      }
      let tourSummary = _.cloneDeepWith(this.$root.paymentTypes, customizer);
      tourSummary = _.mapKeys(tourSummary, item => item.Id);
      _.forEach(this.orders, (order) => {
        tourSummary[order.PaymentTypeId].Summary = tourSummary[order.PaymentTypeId].Summary || 0;
        tourSummary[order.PaymentTypeId].Summary += order.Summary;
      });
      return tourSummary;
    },
  },
  watch: {
    orders() {
      // this.isDirty = true;
    },
  },
  methods: {
    getHeadPartnerReception(orders) {
      console.log(_.head(orders));
      return orders ? `${_.head(orders).Point.Reception} ${_.head(orders).Point.DirectorPhone}` : '';
    },
    async fetchTours() {
      const { data } = await get(`${process.env.VUE_APP_API_HOST}admin/tour`);
      this.tours = data;
    },
    async fetchLastDispatches() {
      const { data } = await get(`${url}/last-dispatches`);
      this.lastDispatches = data;
    },
    async searchOrders() {
      try {
        this.isLoading = true;
        this.orders = [];
        const { data } = await get(`/admin/dispatch/partner-orders-by-date/${this.currentTour.Id}/${this.dispatchDate}`);
        console.log(data);
        this.orders = data.data;
      } catch (e) {
        console.log(e);
        alert('Ошибка');
      } finally {
        this.isLoading = false;
        this.isDirty = true;
      }
    },
    print() {
      this.$htmlToPaper('printMe');
    },
    setFormData(dispatch) {
      const { Date, TourId } = dispatch;
      this.dispatchDate = Date;
      this.currentTour = _.findLast(this.tours, { Id: TourId });
      this.searchOrders();
    },
    resetForm() {
      this.orders = [];
      this.isDirty = false;
      this.dispatchDate = null;
      this.currentTour = null;
    },
  },
};
</script>
